import { useCallback } from "react";
import { getIn } from "formik";
import Card from "@druva-apps/orion/lib/card";
import Col from "@druva-apps/orion/lib/col";
import Input from "@druva-apps/orion/lib/input";
import Label from "@druva-apps/orion/lib/label";
import Row from "@druva-apps/orion/lib/row";
import ToggleButton from "@druva-apps/orion/lib/toggleButton";
import { getIsInputVaild } from "components/Field";
import ModalForm from "shared/ModalForm";
import {
  AllowedToDelete,
  AllowedToDeleteNow,
  AllowedToResetPassword,
  AllowedToResetPasswordAdminEmail,
  ExtendEvaluationPeriod,
  getValidationSchema,
} from ".";

const UpdatePermissionForm = ({
  closeModal,
  initialVaue,
  isOpen,
  updatePermission,
}) => {
  const handleSubmit = useCallback(
    (model) => {
      const updatedDataModel = { ...model };

      if (!updatedDataModel?.[AllowedToDelete]) {
        updatedDataModel[AllowedToDeleteNow] = false;
      }

      if (!updatedDataModel?.[AllowedToResetPassword]) {
        updatedDataModel[AllowedToResetPasswordAdminEmail] = "";
      }

      updatePermission(updatedDataModel);
    },
    [updatePermission],
  );

  return (
    <ModalForm
      disableSubmitWhenInvalid
      closeModal={closeModal}
      withValidation
      header="Edit Advance Settings"
      isOpen={isOpen}
      size="lg"
      onSubmit={handleSubmit}
      initialValues={initialVaue}
      validationSchema={getValidationSchema}
      renderChildren={(props) => {
        return (
          <Card
            fullHeight
            title={() => <Card.Title collapsible title="Advance Settings" />}
            body={() => (
              <div className="oui-ml-1">
                <Row className="oui-mb-2 oui-mt-2">
                  <Col>
                    <ToggleButton
                      isActive={getIn(props.values, AllowedToDelete)}
                      name={AllowedToDelete}
                      onClick={props.setFieldValue}
                      label="Enable Delete Tenant"
                    />
                    <Label
                      text="Once enabled, MSP administrators will be able to delete all associated tenants."
                      className="oui-ml-4 oui-pl-3 font-12"
                      muted
                    />
                  </Col>
                </Row>
                {getIn(props.values, AllowedToDelete) && (
                  <Row>
                    <Col className="oui-pl-4 oui-pr-4">
                      <Row>
                        <Col className="oui-ml-4 oui-pl-4 oui-mb-2">
                          <Input
                            type="checkbox"
                            id={AllowedToDeleteNow}
                            name={AllowedToDeleteNow}
                            label="Allow Delete Immediately"
                            checked={getIn(props.values, AllowedToDeleteNow)}
                            value={getIn(props.values, AllowedToDeleteNow)}
                            onChange={({ target: { name, value } }) =>
                              props.setFieldValue(name, !value)
                            }
                          />
                        </Col>
                      </Row>
                      <Card
                        className="oui-ml-4 oui-mr-4 oui-mb-2 card-background-grey"
                        body={() => (
                          <>
                            <Row className="oui-mt-1">
                              <Col className="oui-text-muted font-12">
                                <ul className="oui-pl-4 oui-mb-0">
                                  <li>
                                    MSP administrator will delete the tenant
                                    permanently.
                                  </li>
                                  <li>
                                    All the associations and storages to this
                                    tenant cannot be recovered.
                                  </li>
                                  <li>
                                    Proceed with caution. Valid for 24 hours
                                    only.
                                  </li>
                                </ul>
                              </Col>
                            </Row>
                          </>
                        )}
                      />
                    </Col>
                  </Row>
                )}
                <Row className="oui-mb-2 oui-mt-4">
                  <Col>
                    <ToggleButton
                      isActive={getIn(props.values, AllowedToResetPassword)}
                      name={AllowedToResetPassword}
                      onClick={props.setFieldValue}
                      label="Enable Reset Password"
                    />
                    <Label
                      text="The email must belong to the MSP admin for sharing API access to reset password. The flag will be automatically disabled if:"
                      className="oui-ml-4 oui-pl-3 font-12 oui-mb-0"
                      muted
                    />
                    <Label
                      text="Reset Password API has been successfully used or the API has remained unused for 24-hours"
                      className="oui-ml-4 oui-pl-3 font-12"
                      muted
                    />
                  </Col>
                </Row>
                <Row className="oui-ml-4 oui-mb-4">
                  <Col sm={{ size: 3 }}>
                    <Label muted text={"Email ID"} />
                  </Col>
                  <Col sm={{ size: 5 }} className="oui-pl-0">
                    <Input
                      type="text"
                      name={AllowedToResetPasswordAdminEmail}
                      id={AllowedToResetPasswordAdminEmail}
                      validationProps={props}
                      isInvalid={getIsInputVaild(
                        props,
                        AllowedToResetPasswordAdminEmail,
                      )}
                      placeholder="Email to send password reset link"
                      disabled={!props.values.allowedToResetPassword}
                    />
                  </Col>
                </Row>
                <Row className="oui-mb-2 oui-mt-4">
                  <Col>
                    <h6 className="oui-mb-0 oui-mr-2">License Period</h6>
                  </Col>
                </Row>
                <Row className="">
                  <Col sm={{ size: 3 }}>
                    <Label text="Evaluation License Period" muted />
                  </Col>
                  <Col sm={{ size: 3 }} className="oui-pl-0">
                    <Input
                      type="number"
                      name={ExtendEvaluationPeriod}
                      id={ExtendEvaluationPeriod}
                      validationProps={props}
                      isInvalid={getIsInputVaild(props, ExtendEvaluationPeriod)}
                      placeholder="Enter period"
                    />
                  </Col>
                </Row>
                <Row className="oui-ml-4 oui-mb-4">
                  <Col sm={{ size: 2 }}></Col>
                  <Col>
                    <Label
                      text="Default is 60 days"
                      className="oui-ml-2 oui-pl-3 font-12 oui-mt-2 oui-mb-0"
                      muted
                    />
                  </Col>
                </Row>
              </div>
            )}
          />
        );
      }}
      submitButtonLabel="Save"
    />
  );
};

export default UpdatePermissionForm;
